import { createAction, createStandardAction } from 'typesafe-actions'
import { createErrorAction } from '@chegg-wt/core/utils/actions'
import { FormType } from '@chegg-wt/core/constants/form'
import { SiteTheme } from '@chegg-wt/core/theme/styled'
import {
  FILL_FORM,
  FORM_FETCH_SUCCEEDED,
  FORM_FETCH_FAILED,
  MANUAL_FORM_INITIALIZED,
  FORM_REQUESTED,
  FORM_SUBMIT_FAILED,
  FORM_SUBMIT_REQUESTED,
  FORM_SUBMIT_SUCCEEDED,
  FORM_LOADED,
  FORM_SUBMIT_START,
  FORM_SUBMIT_STOP,
  FORM_TITLE_FETCHED,
  FORM_AUTH_COMPLETE,
} from './constants'
import { FillFormMeta, FormPageAuthCompletePayload } from './types'

export const manualFormInitialized = createStandardAction(MANUAL_FORM_INITIALIZED)()

export const formRequested = createAction(FORM_REQUESTED, (action) => {
  return (formType: FormType) => action(undefined, { formType })
})

export const formFetchSucceeded = createAction(FORM_FETCH_SUCCEEDED, (action) => {
  return (form: string) => action({ form })
})

export const formFetchFailed = createErrorAction(FORM_FETCH_FAILED)

export const formLoaded = createAction(
  FORM_LOADED,
  (action) => (style: string, sourceType: string) => action({ style, sourceType })
)

export const fillForm = createAction(FILL_FORM, (action) => {
  return (
    navigateFn: FillFormMeta['navigateFn'],
    onUserClickAddAnnotationCTA: FillFormMeta['onUserClickAddAnnotationCTA'],
    title: string,
    onUserClickAddContributorsCTA: FillFormMeta['onUserClickAddContributorsCTA'],
    theme: SiteTheme,
    isSubmitting?: boolean
  ) =>
    action(undefined, {
      navigateFn,
      onUserClickAddAnnotationCTA,
      title,
      onUserClickAddContributorsCTA,
      theme,
      isSubmitting,
    })
})

export const formTitleFetched = createAction(FORM_TITLE_FETCHED, (action) => {
  return (title: string) => action({ title })
})

export const formSubmit = createStandardAction(FORM_SUBMIT_REQUESTED)()
export const formSubmitStarted = createStandardAction(FORM_SUBMIT_START)()
export const formSubmitStopped = createStandardAction(FORM_SUBMIT_STOP)()
export const formSubmitted = createStandardAction(FORM_SUBMIT_SUCCEEDED)()
export const formSubmitFailed = createErrorAction(FORM_SUBMIT_FAILED)

export const formPageAuthComplete = createStandardAction(
  FORM_AUTH_COMPLETE
)<FormPageAuthCompletePayload>()
